module.exports = __webpack_public_path__ + "static/img/btor-90.63ca1dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/btor-90.jpg
// module id = Q62X
// module chunks = 0